import { removeFolderInStorage } from "@/features/PromptbookRuntime/files/removeFolderInStorage";
import { deleteResource } from "@/features/Resources/actions/deleteResource";

export const deletePromptbook = async (promptbookId: string) => {
  await deleteResource(promptbookId);
  removeFolderInStorage("promptbooks", `${promptbookId}/files`);
};
